import { useEffect, useMemo, useState } from 'react'
import UzytkownicyService from '@/services/UzytkownicyService'

function formatTrainerLabel(item) {
	const name = `${item?.nazwa || item?.name || ''}`.trim() || '-'
	const city = `${item?.miasto || item?.city || ''}`.trim()
	return city ? `${name} (${city})` : name
}

const trainerFilterOptions = {
	limit: 200,
	sortColumn: 'nazwa',
	sortDirection: 'asc',
	filters: { isTrainer: true },
}

export default function useTrenerFilterModal(isOpen, selectedTrainerId) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedTrainerId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedTrainerId || '')
	}, [isOpen, selectedTrainerId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const result = query
				? await UzytkownicyService.search(query, trainerFilterOptions)
				: await UzytkownicyService.getAll(trainerFilterOptions)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatTrainerLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatTrainerLabel,
		clearFilter: () => setActiveId(''),
	}
}
